/*
 * @Author: Ximen
 * @Date: 2021-04-06 17:58:21
 * @LastEditors: Ximen
 * @LastEditTime: 2021-04-06 17:58:41
 */
const text = `
海带云B2B商城软件订购及服务协议
一、导语
(一)【审慎阅读】当你点击同意本协议之前，请务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。免除或者限制责任的条款将以粗体下划线标识，你应重点阅读。如甲方对协议有任何疑问，可向杭州诚淘客服咨询。
(二)【签约流程】当你按照页面提示完成操作后，即表示你已充分阅读、理解并接受本协议的全部内容。阅读本协议的过程中，如果你不同意本协议或其中任何条款约定，你应立即停止签约流程。
(三)【软件系统】海带云B2B商城软件服务（以下简称“本服务”）是由杭州诚淘网络科技有限公司向海带云B2B商城商家（以下简称“你”）提供的海带云B2B商城软件系统（以下简称“本系统”）。
二、协议的生效与变更
(一)【协议变更】杭州诚淘可能根据国家法律法规变化、业务调整、产品更新及维护交易秩序、保护消费者权益等需要对协议内容进行变更，变更后的协议内容将更符合业务实际及更好的保障双方权益。如你不同意变更内容，你有权于变更内容确定的生效日前联系杭州诚淘反馈意见，杭州诚淘将根据你的反馈酌情调整变更事项。
(二)【协议生效】变更后的协议版本至公布期满之日起生效，将替代变更前的协议版本，你可在杭州诚淘规则中心查阅最新版协议条款。
(三)【民事权利能力和民事行为能力】你确认，你具有法律规定的完全民事权利能力和民事行为能力，能够独立承担民事责任。若你不具备与前述行为相适应的民事行为能力，则你及你的监护人应依照法律规定承担因此而导致的后果。
(四)【补充协议】因你与杭州诚淘签署的本协议列明的条款并不能完整罗列并覆盖你与杭州诚淘所有权利与义务，现有的约定也不能保证完全符合未来发展的需求。因此，与本服务相关的规则均为本协议的补充协议，包括用户协议及隐私政策,杭州诚淘与你均需遵守，与本协议不可分割且具有同等法律效力。


三、定义
(一)【B2B商城软件服务】B2B商城软件服务是指杭州诚淘为你提供的一套统一的店铺管理及销售解决方案，你可自行根据自己实际店铺使用情况运营和管理。
(二)【消费者】是指与你店铺发生关联行为或在你的B2B商城店铺购买商品或服务的买家。
(三年)【关联店铺】关联店铺指与你为同一认证主体、同一提现银行卡、同一登录手机号及同一负责人的店铺。同一认证主体包括不限于同一实际控制人、关联公司、直系亲属。

四、海带云B2B商城店铺相关
(一)店铺流程相关
1.【店铺创建】你需注册成为杭州诚淘用户后才能进行B2B商城店铺的创建。你应保证在创建B2B商城店铺过程中提供的信息是真实、合法、准确的。
2.【店铺名称】你在创建店铺或修改店铺名称时，不得侵犯他人商标权，亦不得使用违反公序良俗及法律法规要求的名称。为了合规和对店铺做区分，杭州诚淘设置了店铺名称不能重复的系统规则，实行先到先得，商标优先的原则。
3.【店铺免费试用期】你店铺创建成功后，杭州诚淘将给你提供7天免费试用期，店铺试用期期间最多可以使用100笔订单。试用期内的店铺亦需遵守本协议的所有规定。试验期结束后，若你未订购本软件，你的店铺将停止营业，但你仍需就未完成的交易及纠纷进行处理，并且你向杭州诚淘发出结算指令（如有店铺余额）需同时满足：（1）所有订单是完成状态；（2）无交易纠纷；（3）该店铺完成认证。杭州诚淘才会将你的结算指令转达给第三方支付公司，由第三方支付公司向你结算款项。
4.【店铺认证】为保障你的权益，你应及时进行店铺主体认证，如因你未及时、准确的进行店铺认证造成你部分权益无法实现的，由你自行承担相关责任。
1.【店铺资料】你保证提供的文件内容真实有效，由于信息虚假或不准确造成的后果与损失由你承担。你的名称、地址和有效联系方式、许可证等信息发生变化的，你应在一个工作日内通过店铺后台提交最新的信息进行认证。
2.【店铺转让】仅当有法律明文规定、司法裁定或经杭州诚淘同意，并符合杭州诚淘规定的店铺转让流程的情况下，你方可进行店铺转让。你的店铺一经转让，权利义务一并转移。除此之外，你的店铺不得以任何方式转让，否则你需承担由此产生的责任及后果。
(二)店铺安全相关
1.你应妥善保管账号及密码，杭州诚淘任何时候均不会主动要求你提供账户及密码。店铺账号项下所进行的一切操作均视为你的行为，你应对该操作依法享有权利并承担相关责任。因此你同意：
1)请你务必妥善保管及正确、安全使用海带云B2B商城店铺账号、密码及其他账号要素。
2)及时更新“海带云B2B商城店铺”账号的管理员权限，并且店铺账号下的其他管理员的操作视为已获得你的授权并允许其进行管理。除杭州诚淘存在法定过错外，你应对你账号项下的所有行为结果（包括但不限于在线签署各类协议、发布信息、购买商品及服务及披露信息等）负责。
3)因黑客行为、他人诈骗行为或你的保管疏忽导致账号非法使用，你应通过司法、行政等救济途径向侵权行为人追偿，杭州诚淘将积极配合你提供相应的帮助，但杭州诚淘不因此而承担责任，如杭州诚淘存在法定过错的，杭州诚淘应当承担你的直接损失，但直接损失不得超过本合同订购总金额。


五、支付及结算业务概述
 (一)支付业务及手续费相关
  1.若你开通第三方支付公司业务，你的交易款项系由消费者通过第三方支付公司支付至你的账户，第三方支付公司因此会按照行业通用标准向你单独收取交易手续费用，你理解并同意，该费用是第三方支付公司基于其向你提供的支付服务所收取的费用，与杭州诚淘向你提供的本项服务无关。
  (二)海带云B2B商城交易服务相关
 1.【海带云B2B商城交易服务】杭州诚淘向你提供货款结算的中介服务，你理解并同意以下条款：
1）【交易纠纷处理途径】你在杭州诚淘店铺交易过程中与消费者发生争议的，你有权选择以下途径解决：
a) 与争议相对方自主协商；
b) 使用杭州诚淘提供的客服接入服务；
c) 请求依法成立的调解组织调解；
d) 向有关行政部门投诉；
e) 根据与争议相对方达成的仲裁协议（如有）提请仲裁机构仲裁；
f) 向人民法院提起诉讼。
2）如你未选择上述争议解决途径，依据杭州诚淘纠纷处理规则进行解决的，则表示你认可杭州诚淘作为独立的第三方根据其所了解到的争议事实并依据杭州诚淘规则所作出的决定（包括调整相关订单的交易状态、判定将争议款项的全部或部分支付给交易一方或双方等）。在杭州诚淘决定作出前，你仍可选择上述争议处理途径。如你对杭州诚淘处理决定不满意的，你仍有权采取其他争议处理途径解决争议，但通过其他争议处理途径未取得终局决定前，你仍应先履行处理决定。
2.【交易风险】当你通过本服务进行各项交易或接受交易款项时，若你或交易对方未遵从本服务条款或网站说明、交易页面中之操作步骤，则杭州诚淘有权拒绝为你与交易对方提供相关服务。若发生上述状况，而款项已先行划付至你的海带云B2B商城商户账户名下，你同意杭州诚淘有权直接自相关账户余额中扣回款项。此款项若已汇入你的银行账户，则杭州诚淘有权保留事后索回权利。

3.【交易状态】杭州诚淘会以电子邮件、App消息、站内信（或发送到该手机的短信或电话等）方式通知你交易进展情况以及提示你进行下一步的操作。因此，在交易过程中你应当及时登录到杭州诚淘网站查看和进行交易操作。因你没有及时查看和对交易状态进行修改或确认或未能提交相关申请而导致的纠纷或损失，你需自行承担。
4.【货物交付】若你需要向交易对方（以下简称：消费者）交付货物，应根据交易状态页面显示的买方地址，委托有合法经营资格的承运人将货物直接运送至对方或其指定收货人，因货物延迟送达或在送达过程中的丢失、损坏，应由你与交易对方协商处理。
5.如果你与消费者发生交易纠纷，杭州诚淘有权根据本协议及杭州诚淘官网上载明的各项规则进行处理。你为解决纠纷而支出的通讯费、文件复印费、鉴定费等均由你自行承担。因市场因素致使商品涨价跌价而使任何一方得益或者受到损失而产生的纠纷，杭州诚淘不予处理。
6.你同意，基于运行和交易安全的需要，杭州诚淘可以暂时停止提供或者限制本服务部分功能，或提供新的功能，在功能减少、增加或者变化时，涉及到你重大利益的，杭州诚淘会提前通过站内信等方式通知你，预留合理时间并听取商家意见反馈。在你有效的服务期限内，杭州诚淘不会变更你本次付费订购软件服务的费用。


六、软件服务费、服务期限及续费相关规则
   (一)你使用本服务前，应事先注册、开通海带云B2B商城店铺。产品服务费价格，服务时间以及包含的产品功能会根据市场情况发生变更，具体以订购时页面展示为准。

(二)你支付服务费时，可选择店铺余额或在线支付（微信/支付宝扫码进行支付），亦可选择对公转账至杭州诚淘如下账户支付所需订购内容的服务费用，杭州诚淘账户信息如下：
 开户行：xxxx
 账  号：xxx
 户  名：xxxx
(三)一旦订购成功，你即可开始使用本服务。如你需使用本服务中额外收费的功能、工具等，你须额外支付相应的费用才能使用。
(四)你同意一旦订购本服务且支付软件服务费，除杭州诚淘书面同意外，杭州诚淘不因本协议的中止、终止或你单方面退出而将已支付的软件服务费退还给甲方。
（五）【云服务费】杭州诚淘为所有商家提供了安全高效的交易营销服务，保证在商家店铺交易的消费者都能获得优质的购物体验，杭州诚淘也为此投入了大量的技术成本，为保证该服务持续为商家赋能，杭州诚淘有权在后续就产生云服务的订单收取相应的费用。
（六）本协议服务期均从你开通之日起开始计算；若你进行版本升级，服务期的计算方式根据实际情况进行计算。你可在“海带云B2B商城店铺后台-资产-我的交易-订购”中查看订购记录。
（七）【续费】如你在到期前或到期当天续费的，新的服务期从原服务期到期的次日开始计算；若你在原服务期到期之后续费的，新的服务期于你续费完成之日起开始计算。
（八）【发票】如你需要发票，在开通服务后杭州诚淘可开具项目为“＊信息技术服务＊软件服务费”的增值税发票。
（九）【收费调整】杭州诚淘向你提供的服务付出了大量的成本，除杭州诚淘明示的收费业务外，杭州诚淘提供的服务目前是免费的。如未来杭州诚淘向你收取合理费用，杭州诚淘会采取合理途径并以足够合理的期限提前通过站内信、公告等并方式通知甲方，确保你有充分选择的权利。

七、双方的权利与义务
   (一)你的权利与义务
1.当你通过海带云B2B商城店铺向消费者展示商品/服务的具体信息，你应按照法律法规的要求详细说明商品/服务的使用方式方法、涵盖的内容等。你提供的商品/服务应符合国家法律、法规、规章的规定。如因你的商品/服务造成消费者损失或损害的，由你承担相应的赔偿责任，如杭州诚淘基于前述情况向消费者先行赔付的，杭州诚淘有权向你追偿，经通知你不配合支付的，杭州诚淘有权对你账户采取冻结、锁定提现、扣减余额等措施。
2.你应保证通过海带云B2B商城店铺的商品/服务在你的经营范围之内，应保证自身具备相应的许可资质，销售的商品/服务质量符合国家相应的安全标准、生产标准，如售卖医疗器械、食品、出版物及药品等。因你或其提供的商品/服务不符合国家法律、法规、规章的规定，或存在商品/服务质量和安全问题，由此造成的消费者投诉、索赔、经济损失等相关后果均由你承担。
3.如你的部分服务发生变更（包括但不限于服务内容、时长、项目等）或需下架的，你应及时更新或下架相应商品/服务的相关页面信息，如因你未及时更新但有消费者下单购买相关需变更或下架的商品/服务，而你又不能按照约定提供的，你应立即电话通知下单的消费者，并做好合理的安抚和处理措施，如因此造成消费者投诉、经济损失等相关后果均由你承担。
4.你同意将不会利用本服务进行任何违法或不正当的活动，如经杭州诚淘确认你有此类行为的，杭州诚淘有权直接作删除内容、商品下架等处理，除杭州诚淘存在法定过错外，杭州诚淘对此类行为不承担责任，由你自行承担由此引起的责任。若有导致杭州诚淘受损的，你亦应对此承担赔偿责任。此类行为包括但不限于下列行为∶
1) 侵害他人名誉权、隐私权、商业秘密、知识产权等合法权益；
2) 违反依法定或约定之保密义务；
3) 冒用他人名义使用本服务；
4) 从事不法交易行为，如洗钱、贩卖枪支、毒品、禁药、盗版软件、黄色淫秽物品、及其他杭州诚淘认为不得使用本服务进行交易的物品等；
5) 提供赌博资讯或以任何方式引诱他人参与赌博；
6) 进行与你或交易对方宣称的交易内容不符的交易，或不真实的交易；
7) 从事任何可能含有电脑病毒或是可能侵害本服务系统、资料之行为；
8) 含有中国法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容的；
9) 其他杭州诚淘有正当理由认为不适当之行为。
5.如你的行为给杭州诚淘造成损失，你应承担相应的赔偿责任，赔偿责任包括但不限于下列:
1) 如你的行为使杭州诚淘及/或其关联公司遭受损失（包括自身的直接经济损失、商誉损失及对外支付的赔偿金、和解款、律师费、诉讼费等间接经济损失），你应赔偿杭州诚淘及/或其关联公司的上述全部损失。
2) 如你的行为使杭州诚淘及/或其关联公司遭受第三人主张权利，杭州诚淘及/或其关联公司，可在对第三人承担金钱给付等义务后就全部损失向你追偿。
3) 如因你的行为使得第三人遭受损失或你怠于履行调处决定的，杭州诚淘可从你的店铺余额中划扣相应款项进行支付。如你的店铺余额或保证金不足以支付相应款项的，你同意委托杭州诚淘使用自有资金代你支付上述款项，你应当返还该部分费用并赔偿因此造成杭州诚淘的全部损失。
   (二)杭州诚淘权利与义务
1.杭州诚淘为你提供本合同项下约定的海带云B2B商城服务，并且保证系统的稳定性，若系统出现宕机等情况，杭州诚淘需要按照相关规定对你进行补偿。
2.杭州诚淘有权对你在店铺发布的内容、信息进行核查，必要时通知你删改。杭州诚淘有权利对不符合法律法规、政策规定的内容、商品/服务予以删改或直接进行商品/服务的封锁、下架处理，但你确认，除杭州诚淘存在法定过错外，杭州诚淘的前述核查、删改等行为不为杭州诚淘设置任何义务，也不免除你本合同应承担的责任。
3.如消费者就你商品/服务向杭州诚淘投诉，杭州诚淘经核实后，有权要求你配合解决该投诉。如你拒绝或怠于解决投诉，引发消费者再次投诉或投诉至有关部门的，杭州诚淘有权就相关规则或基于基本的道德对你与消费者的纠纷进行处理，包括但不限于在作出相应处理决定后直接作出处理等。
4.你因本协议第七条出现的情形造成杭州诚淘损失，经杭州诚淘催告后仍然不支付相应费用的，则杭州诚淘有权通过短信、站内信、App通知等方式告知你，若你仍不配合支付，一旦你店铺余额资金大于0，则杭州诚淘有权不经你同意直接扣除。
5.合作期间，杭州诚淘会对数据资料进行妥善保管不对外泄露。若属于你能合理使用的数据，你应提前做好备份，你确认，杭州诚淘在合作结束的15天后对你所有数据不再负有托管、保存的义务，杭州诚淘可根据实际业务情况进行删除等操作。

八、知识产权
(一)为了保证你的利益，杭州诚淘可能不定时会为你进行宣传，你需要自动授权杭州诚淘在杭州诚淘及杭州诚淘关联的公司网站、宣传资料、媒体渠道等页面及资料上无偿使用你的品牌、商标等进行展示和宣传，但杭州诚淘不得用于有损你品牌的用途。
(二)你保证与商品相关的专利、商标、名称、特有标识、装潢、技术秘密、图片等已按照法律规定或者合同约定获得了销售商品的合法授权或许可，因杭州诚淘可能会为商家的商品进行宣传、品牌背书等行为，你同意授权杭州诚淘为在本协议下目的使用相关知识产权，该授权许可是免费的、非独家的。
(三)杭州诚淘或其关联方拥有、使用、许可、控制的或者杭州诚淘或其关联方对之享有其他权利的所有知识产权、工业产权和专有权利，如你需要使用，可按照官网公示的途径向杭州诚淘申请，非经杭州诚淘或其关联公司书面同意，任何人不得擅自使用、修改、复制、公开传播、改变、散布、发行或公开发表在杭州诚淘网站上的程序或内容。你不得恶意申请和注册与杭州诚淘及杭州诚淘关联方相同或近似的商标、名称、标识、标志、微信公众号、域名、网页等，用于开展与杭州诚淘及杭州诚淘关联方实质相同或近似的业务。
(四)若你违反本条之约定而给杭州诚淘及/或杭州诚淘关联方造成损失的，你应赔偿全部损失并消除给杭州诚淘及/或杭州诚淘关联方造成的不良影响，同时杭州诚淘有权要求第三方支付公司对你采取限制店铺资金提现、直接自你店铺资金中扣划损失赔偿金等措施，并有权立即解除本协议。

九、消费者数据使用和保护
    (一)杭州诚淘将采取安全技术措施和保密措施，以保障你的数据安全。
  (二)就你使用本服务所收集、储存、处理、使用的消费者的数据和实施任何与这些数据有关的活动当符合以下要求：
1.你应当遵守与法律法规、本协议和杭州诚淘规则的规定。
2.你应当按照法律法规要求制定隐私保护政策来搜集和使用消费者数据，这些政策能够清晰并准确地向消费者说明你收集的具体个人数据信息内容，如何使用这些信息，以及如何与第三方共享这些信息。你隐私政策内容应至少遵从本协议以及杭州诚淘的隐私保护政策的要求。
3.在合作的过程中，你可能会因为业务经营的需要要求杭州诚淘提供一些合法的个人数据。对于杭州诚淘提供的任何个人数据，因杭州诚淘需要符合相关的法律要求并承担相关的法律责任，因此你应当仅能依据杭州诚淘提供的要求来使用这些数据。在杭州诚淘因客观情况变化时要求你删除这些数据的情况的，你应当积极配合杭州诚淘删除这些数据并不得私自进行保存。

(三)为保障消费者的权益 ，你需在符合国家法律规定的前提下方可将其个人数据传送给其他任何国家或第三方。
(四)一旦你停止使用本服务，或杭州诚淘基于任何原因终止使用本服务，若你有权使用的数据应提前做好备份，其他数据必须立即删除（包括各种备份），且不得再以任何方式进行使用。

十、违约责任
(一)【违约处罚】如杭州诚淘发现你存在违反法律法规及政策规定、本协议或相关服务条款的，杭州诚淘有权按照杭州诚淘相关规则或相关法律法规对你采取必要措施，包括但不限于终止部分或全部服务、断开链接等。
(二)【违约责任承担】若因你违反本协议的保证与承诺而给任何第三方造成损失的，应当自行负责处理由此产生的争议，并承担全部法律责任（包括但不限于赔偿由此给消费者、杭州诚淘及/或任何他方造成的全部损失），若杭州诚淘因此遭受损失或进行先行赔偿的，杭州诚淘有权向你追偿。
(三)【违约公示】杭州诚淘可将对你上述违约行为处理措施信息以及其他经国家行政或司法机关生效法律文书确认的违法信息在杭州诚淘上予以公示。

十一、免责声明
(一)【损害赔偿的免责】你理解并同意，杭州诚淘不对因下述情况导致的损害赔偿承担责任，包括但不限于利润、商誉、使用、数据等方面的损失或其他无形损失的损害赔偿：
1.杭州诚淘有权基于综合判断，包含但不限于杭州诚淘认为你已经违反本协议的规定及法律法规的要求，暂停、中断或终止向你提供本服务或其任何部分，并移除你的资料。
2.杭州诚淘在发现交易异常或你有违反法律规定或本协议约定的行为时，有权按照法律规定暂停或终止该B2B商城店铺的使用（包括但不限于对该店铺名下的款项和在途交易采取取消交易、调账等限制措施），并拒绝提供你使用本服务之部分或全部功能。
3.在极端特殊场景下，杭州诚淘将终止提供本服务，暂停、关闭或删除该店铺及你店铺中所有相关资料及档案，并通知第三方支付公司将你滞留在该店铺余额的全部合法资金退回到你的银行账户。
(二)【系统中断或故障的免责】系统因下列状况无法正常运作，导致你无法使用各项服务的，杭州诚淘不承担损害赔偿责任，该状况包括但不限于：
1.杭州诚淘在杭州诚淘官网公告之系统停机维护期间；
2.电信设备出现故障不能进行数据传输的；
3.因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力之因素，造成杭州诚淘系统障碍不能执行业务的；
4.由于电信部门技术调整或故障、网站升级、银行方面的问题等原因而造成的服务中断或者延迟。
(三)【特殊情况的免责】对下列情形，杭州诚淘不承担任何责任：
1.并非由于杭州诚淘存在法定过错而导致本服务未能提供的；
2.由于你的原因导致任何第三方遭受损失的；
3.因你未及时续费，导致本服务不能提供或提供时发生任何错误，你须自行承担因此产生的一切后果，杭州诚淘不承担任何责任。
（四）【版本更新的免责】为了改善消费者体验、完善服务内容，杭州诚淘将不断努力开发新的服务，并为你不时提供内容或系统的更新（这些更新可能会采取软件替换、修改、功能强化、版本升级等形式）。为了保证本服务的安全性和功能的一致性，杭州诚淘可能不经向你特别通知而对内容或系统进行更新，或者对软件的部分功能效果进行改变或限制。新版本发布后，旧版本的服务可能无法使用。请你随时核对并下载最新版本。

十二、协议中止、解除及终止
(一)【协议解除/终止】出现下列情形之一的，杭州诚淘有权单方解除/终止本协议，并有权要求商家承担有可能发生的违约责任：
1.你订购的本服务期到期，且甲方未续费的；
2.你从事其店铺的经营事项的合法资格消失；
3.杭州诚淘接到相关部门的通知，你被相关部门要求停业整顿或其他行政处罚的；
4.你违反杭州诚淘公布的相关协议或规则，被清退的；
5.你出现违规或违法行为的，严重损害杭州诚淘或者消费者利益的；
6.其它杭州诚淘有正当理由认为需中止/终止服务的情况。
（二）【协议期限】本协议期限为自订购之日起（存在试用期的、赠送服务期的，以商家实际使用服务之日起算）至协议解除/终止之日止；若涉及保密、违约责任、售后服务义务及产品质量保证责任等内容在协议解除/终止后将继续有效。

十三、协议中止/解除/终止后处理
(一)【账号处理】自本协议中止、终止或解除之日起，杭州诚淘将关闭商家在杭州诚淘的部分店铺后台管理权限，并对商家产品全部下架，杭州诚淘不再对外展示任何商家产品信息。
(二)【数据处理】本协议中止、终止或解除后，杭州诚淘有权按照法律法规的要求保留你交易行为记录等数据，因双方协议已经终止，杭州诚淘保存数据需要巨大的技术成本，所以杭州诚淘不再为你保留这些数据且没有保留义务，亦不承担在协议终止后向你或第三方提供任何数据信息的义务，但法律另有规定的除外。
(三)【交易处理】因你违反法律法规或者违反本服务协议规定而致使杭州诚淘中断、终止对你提供服务的，对于服务中断、终止之前你的交易行为依下列原则处理：
1.服务中断、终止之前，你已经上传至海带云B2B商城的商品/服务尚未交易或尚未交易完成的，杭州诚淘有权在中断、终止服务的同时删除或下架此项商品/服务的相关信息；
2.服务中断、终止之前，你已经与交易对方就具体交易达成一致，杭州诚淘可以不删除该项交易，但杭州诚淘有权在中断、终止服务的同时将你被中断或终止服务的情况通知你的交易对方。
(四)【不免除售后责任】本协议终止或解除并不免除商家依据本协议应向消费者承担的售后服务及产品保证责任，商家仍应履行售后服务义务及产品质量保证责任；如在本协议终止后，因售后服务问题或商家产品质量问题导致杭州诚淘或其他第三方人身或财产损失的，商家仍应承担其责任。

十四、通知与送达
(一)【通知实时关注】杭州诚淘将选择向你进行店铺认证时预留的电话或你店铺站内信等联系通道的其一或若干送达各类通知，而此类通知的内容可能对你的权利义务产生重大的有利或不利影响，请你务必及时关注。
(二)【通知的送达】本协议签订或履行过程中，杭州诚淘向你寄送的书面通知，在交邮后第五个自然日即视为送达。书面通知形式还包括但不限于在海带云B2B商城公告、向你发送电子邮件、平台站内信、系统信息、手机短信、微信消息和传真等电子方式，在采用电子方式进行通知的情况下，发送当日即视为送达。
(三)【法律文书送达】对于在海带云B2B商城上因交易活动引起的任何纠纷，你同意司法机关及监管部门（包括但不限于人民法院、市场监督管理局）可以通过你在海带云B2B商城注册、更新时提供的手机号码、电子邮箱联系方式以及在注册杭州诚淘用户时生成的账号进行送达，司法机关向上述联系方式发出法律文书即视为送达。你指定的邮寄地址为你的法定联系地址或你提供的有效联系地址。
(四)【联系方式实时更新】你应当保证其提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不正确，或不及时告知变更后的联系方式，使法律文书无法送达或未及时送达，由你自行承担由此可能产生的法律后果。

十五、法律适用、管辖与其他
(一)【法律适用】本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律，没有相关法律规定的，参照通用国际商业惯例和（或）行业惯例。
(二)【管辖法院】你因使用杭州诚淘服务所产生及与杭州诚淘服务有关的争议，由杭州诚淘与你协商解决。协商不成时，任何一方均可向杭州互联网法院提起诉讼。
(三)【条款独立性】如本协议的任何条款被视作无效或无法执行，则上述条款可被分离，其余条款则仍具有法律效力。
(四)【权利放弃】本协议任何一方于另一方过失或违约时放弃本协议规定的权利的，不得视为其对一方的其他或以后同类之过失或违约行为弃权。杭州诚淘未行使或执行本服务协议任何权利或规定，不构成对前述权利或权利之放弃。
(五)【商业贿赂】如你向杭州诚淘及/或其关联公司的雇员或顾问等提供实物、现金、现金等价物、劳务、旅游等价值明显超出正常商务洽谈范畴的利益，则可视为你存在商业贿赂行为。发生上述情形的，杭州诚淘可立即终止与你的所有合作并向你收取违约金及/或赔偿金，该等金额以杭州诚淘因你的贿赂行为而遭受的经济损失和商誉损失作为计算依据。


`;
export default text;
